module.exports = __webpack_public_path__ + "media/images/lb/784-73f5051515f0e83e094ad010c6159364.svg";